export default __webpack_public_path__ + "static/media/propsicon2.b496a444.svg";